import Log from '@/Utils/Log';

// copy to clipboard and restore the original document's selection
// This is deprecated in favor of the async Clipboard API but is still needed as a fallback for unsupported browsers
export const fallbackCopyTextToClipboard = (str) => {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    const selected = document.getSelection().rangeCount > 0
        ? document.getSelection().getRangeAt(0)
        : false;
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
    }
};

export const copyTextToClipboard = async (str) => {
    try {
        if (!navigator.clipboard) {
            fallbackCopyTextToClipboard(str);
            return;
        }
        await navigator.clipboard.writeText(str);
    }
    catch (err) {
        Log.error('Failed to copy text to clipboard', err);
    }
};